module.exports = __webpack_public_path__ + "assets/img/12.4dccaa08.png";